import React from 'react';
import { Box, Fade, Typography } from '@material-ui/core';
import { DOCUMENTS_GRID_FADE_TIMEOUT } from './constants';
import { useDocumentsGridStyles } from './documentsGridStyles';
import { DocumentsGridSkeleton } from './DocumentsGridSkeleton';
import type { TDocumentsGridLayoutProps } from './types';

export const DocumentsGridLayout = ({
    loading,
    documentCount,
    emptyMessage,
    children,
}: TDocumentsGridLayoutProps) => {
    const classes = useDocumentsGridStyles();
    const hasDocuments = documentCount > 0;
    const isSingleItem = documentCount === 1;

    if (loading) {
        return (
            <Box className={classes.container}>
                <DocumentsGridSkeleton />
            </Box>
        );
    }

    if (!hasDocuments) {
        return (
            <Box className={classes.container}>
                <Fade in timeout={DOCUMENTS_GRID_FADE_TIMEOUT}>
                    <Box className={classes.emptyState}>
                        <Typography variant="h3" color="textPrimary">
                            {emptyMessage}
                        </Typography>
                    </Box>
                </Fade>
            </Box>
        );
    }

    return (
        <Box className={classes.container}>
            <Fade in timeout={DOCUMENTS_GRID_FADE_TIMEOUT}>
                <Box
                    className={`${classes.itemContainer} ${
                        isSingleItem
                            ? classes.itemContainerCentered
                            : classes.itemContainerLeft
                    }`}
                >
                    {React.Children.map(children, (child) => (
                        <Box
                            className={`${classes.itemWrapper} ${
                                isSingleItem ? classes.itemWrapperSingle : ''
                            }`}
                        >
                            {child}
                        </Box>
                    ))}
                </Box>
            </Fade>
        </Box>
    );
};
